import { useLimits } from '../state/store';

/* The thin bar under a holding row: weight against its cap, with a marker at the
   cap itself (§7.1). The scale runs to whichever is larger — the cap plus
   headroom, or the current weight — so a breach stays on the bar. */
export function CapBar({ weight, cap, color }: { weight: number; cap: number | null; color: string }) {
  const limits = useLimits();
  if (cap === null) {
    // No band assigned. The bar would imply a limit that does not exist, so the
    // row shows the weight alone and the rule engine asks for the band.
    return null;
  }
  const scaleMax = Math.max(cap * 1.35, weight * 1.08);
  const fillPct = Math.min(100, (weight / scaleMax) * 100);
  const markPct = (cap / scaleMax) * 100;
  const breached = weight > cap;
  const trim = weight > cap * limits.trimTriggerMult;

  return (
    <div
      className="cap-bar"
      role="meter"
      aria-valuenow={Number(weight.toFixed(1))}
      aria-valuemin={0}
      aria-valuemax={Number(cap.toFixed(1))}
      aria-label={`Weight ${weight.toFixed(1)} percent against a ceiling of ${cap} percent`}
    >
      <div
        className="cap-fill"
        style={{
          width: `${fillPct}%`,
          background: trim ? 'var(--crit)' : breached ? 'var(--warn)' : color,
        }}
      />
      <div className="cap-mark" data-breached={breached} style={{ left: `${markPct}%` }} />
    </div>
  );
}
